import { Activity, BookOpen, Code2, Gamepad2, GitCommitHorizontal, LifeBuoy, Radio, ShieldCheck, Sparkles, Target, Users, Video } from "lucide-react";

// Le contenu du site désigne les icônes par leur nom : cette table fait le lien.
export const ICONS = { Activity, BookOpen, Code2, Gamepad2, GitCommitHorizontal, LifeBuoy, Radio, ShieldCheck, Sparkles, Target, Users, Video };
